import { type Dispatch, type SetStateAction, type ReactNode } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { z } from 'zod';
import { type CustomerAddress } from '@hungryroot/pages-checkout';
import { AddressSummary } from '../../Components/AddressSummary/AddressSummary';
import { PaymentForm } from '../../Components/PaymentForm/PaymentForm';
interface Props {
  testid?: string;
  zipCode?: string;
  setPaymentLoading: Dispatch<SetStateAction<boolean>>;
  paymentLoading: boolean;
  orderId: number;
  subtotal: number;
  orderTotal: number;
  address: CustomerAddress;
  deliveryDate: string;
  zipcode: string | undefined;
  customerId?: number;
  plan?: number | null;
  checkoutButton?: () => ReactNode;
}

const STRIPE_KEY = z
  .string({
    invalid_type_error:
      'Unable to parse PUBLIC_STRIPE_KEY. Included in env file?',
  })
  .parse(process.env.PUBLIC_STRIPE_KEY);

export function Payment(props: Props) {
  const {
    testid,
    orderId,
    setPaymentLoading,
    paymentLoading,
    subtotal,
    orderTotal,
    address,
    deliveryDate,
    zipcode,
    customerId,
    plan,
    checkoutButton,
  } = props;
  const stripe = loadStripe(STRIPE_KEY);

  return (
    <div data-testid={testid}>
      <Elements stripe={stripe}>
        <AddressSummary address={address} deliveryDate={deliveryDate} />
        <PaymentForm
          testid={testid}
          orderId={orderId}
          setLoading={setPaymentLoading}
          loading={paymentLoading}
          subtotal={subtotal}
          orderTotal={orderTotal.toString()}
          zipcode={zipcode}
          address={address}
          customerId={customerId}
          plan={plan}
          checkoutButton={checkoutButton}
        />
      </Elements>
    </div>
  );
}
